import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import Typography from '../../atoms/Typography';
import { Container } from './style';

const EmptyCard = ({ message, children }) => (
    <Container variant="outlined" style={{border: 'none'}}>
      <Box display="flex" marginBottom="1rem">
        <WarningIcon />
        <Typography variant="body1"> {message}</Typography>
      </Box>
      <Box>{children}</Box>
    </Container>
  );

EmptyCard.propTypes = {
  message: PropTypes.string,
  children: PropTypes.node,
};

EmptyCard.defaultProps = {
  message: 'Empty data',
  children: undefined,
};
export default EmptyCard;
